import { normalizeApiError } from '../api/apiError';

const MESSAGES: Record<string, string> = {
  WORKFLOW_NOT_FOUND: 'Approval request was not found.',
  WORKFLOW_NOT_ASSIGNED: 'This request is not assigned to you.',
  WORKFLOW_ACTION_NOT_ALLOWED:
    'This workflow action is not currently allowed.',
  WORKFLOW_ALREADY_ACTIONED: 'This request has already been actioned.',
  WORKFLOW_STATE_CHANGED:
    'This request was updated by another approver. Refreshing the latest status.',
  WORKFLOW_STEP_CHANGED: 'The approval step has changed.',
  WORKFLOW_APPROVAL_NOT_AVAILABLE:
    'This workflow action is not currently available.',
  WORKFLOW_REJECTION_NOT_AVAILABLE:
    'This workflow action is not currently available.',
  USE_MODULE_APPROVAL_API:
    'This workflow action is not currently available.',
  USE_MODULE_CANCEL_API:
    'This workflow action is not currently available.',
  WORKFLOW_DELEGATION_NOT_FOUND: 'Workflow delegation was not found.',
  ACCESS_DENIED: 'You do not have permission to perform this action.',
  VALIDATION_ERROR: 'Check the entered workflow information.',
  INVALID_DATE_RANGE: 'The selected date range is invalid.',
  NETWORK_ERROR: 'Unable to connect to the server.',
  REQUEST_TIMEOUT: 'The server took too long to respond.',
};

export function workflowErrorMessage(
  error: unknown,
  fallback = 'Unable to load workflow information.',
): string {
  if (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    typeof (error as { code?: unknown }).code === 'string'
  ) {
    const code = (error as { code: string }).code;
    if (MESSAGES[code]) return MESSAGES[code];
  }

  const apiError = normalizeApiError(error);
  if (apiError.code && MESSAGES[apiError.code]) {
    return MESSAGES[apiError.code];
  }
  return fallback;
}
